var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAnimation)?_c('lottie',{attrs:{"options":_vm.options,"height":_vm.height,"width":_vm.width,"id":_vm.id,"name":_vm.id || _vm.name,"text":_vm.id || _vm.text}}):_c('img',{attrs:{"src":_vm.options,"id":_vm.id,"name":_vm.id || _vm.name,"height":_vm.height,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }